module.exports = __webpack_public_path__ + "img/p_l_s_s_b.cc7d3ad2.jpg";